import SectionService from '../../../../services/SectionService';
import {
  addAsset,
  updateAsset,
} from '../../store/slices/assetsSlice';
import {
  addTimelineItem,
} from '../../store/slices/timelineSlice';
import {
  setQuestionModalVisible,
  setFetchedQuestionData,
  setEditingQuestionContext,
} from '../../store/slices/editorUISlice';

export function createQuestionHandlers({
  dispatch,
  currentTime,
  selectedItemId,
  currentItem,
  isEditMode,
  editingQuestionContext,
}) {
  const handleCreateQuestion = (question) => {
    if (!question) return;
    const questionText = question.text || 'Question';
    const id = `asset-q-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

    const questionAsset = {
      id,
      type: 'question',
      source_type: 'upload',
      name: questionText.length > 60 ? `${questionText.slice(0, 57)}...` : questionText,
      text: question.text,
      isAnswerRequired: !!question.isAnswerRequired,
      options: question.options || { type: 'Single Text Field', options: [] },
      duration: 5,
      metadata: {
        created_at: new Date().toISOString(),
      },
    };

    dispatch({ ...addAsset(questionAsset), meta: { undoable: true } });
    dispatch({
      ...addTimelineItem({
        assetId: questionAsset.id,
        duration: questionAsset.duration,
        currentTime,
        anchorItemId: selectedItemId || currentItem?.id,
      }),
      meta: { undoable: true },
    });

    dispatch(setQuestionModalVisible(false));
    dispatch(setFetchedQuestionData(null));
    dispatch(setEditingQuestionContext(null));
  };

  const handleOpenEditQuestion = (asset, item) => {
    dispatch(setFetchedQuestionData({
      sectionId: asset.metadata?.sectionId || '__local__',
      text: asset.text || '',
      isAnswerRequired: !!asset.isAnswerRequired,
      options: asset.options || { type: 'Single Text Field', options: [] },
    }));
    dispatch(setEditingQuestionContext({
      assetId: asset.id,
      sectionId: asset.metadata?.sectionId || null,
      itemId: item.id,
    }));
    dispatch(setQuestionModalVisible(true));
  };

  const updateQuestionSection = async ({ sectionId, question }) => {
    try {
      if (isEditMode && sectionId) {
        await SectionService.updateSection({
          sectionId,
          question: {
            isAnswerRequired: !!question.isAnswerRequired,
            text: question.text,
            options: question.options || null,
          },
        });
      }

      // Update local asset
      if (editingQuestionContext?.assetId) {
        dispatch({
          ...updateAsset({
            id: editingQuestionContext.assetId,
            changes: {
              name:
                question.text && question.text.length > 60
                  ? `${question.text.slice(0, 57)}...`
                  : question.text || 'Question',
              text: question.text,
              isAnswerRequired: !!question.isAnswerRequired,
              options: question.options || { type: 'Single Text Field', options: [] },
            },
          }),
          meta: { undoable: true },
        });
      }

      dispatch(setQuestionModalVisible(false));
      dispatch(setFetchedQuestionData(null));
      dispatch(setEditingQuestionContext(null));
    } catch (e) {
      // Error is handled globally in services; keep UI stable
    }
  };

  return {
    handleCreateQuestion,
    handleOpenEditQuestion,
    updateQuestionSection,
  };
}

